module.exports = "/_next/static/images/f8617c14a32fd0b4d99ea4077bf44562-right-side-desktop.jpg.webp";